<template>
  <PageContentLayoutOnly>
    <ModernTable :filters="filters" :rows="apLineItems" :columns="columns" :pagination="pagination">
      <template v-slot:header>
        <div class="pb-5">
          <b-button
            :disabled="isPostedAlready || hideCreateButton"
            @click="createLineItemModal()"
            size="is-small"
            type="is-primary"
            rounded
          >
            Create Invoice Charge
          </b-button>
          <b-button
            type="is-ghost"
            @click="toggleFilters"
            :style="styles.filterButton"
            :class="'filter-button ' + (filters.show ? 'active' : '')"
          >
            <b-icon pack="mdi" icon="filter-outline" size="is-small" style="display: inline-block">
            </b-icon>
            <div style="display: inline-block">Filter</div> </b-button
          ><span class="p-2"></span>
          <b-button
            v-if="!hideCreateButton && apLineItems && apLineItems.length > 0"
            :disabled="loading"
            size="is-small"
            type="is-primary"
            rounded
            @click="updateCodingCompleteDate(false)"
          >
            Coding Complete
          </b-button>
          <b-button
            v-if="hideCreateButton"
            :disabled="loading"
            size="is-small"
            type="is-primary"
            rounded
            @click="updateCodingCompleteDate(true)"
          >
            Re-code
          </b-button>
        </div>
      </template>
    </ModernTable>
    <Modal :toggle.sync="toggle">
      <InvoiceChargeModal
        :apInvoiceID="parseInt(apInvoiceID)"
        :apInvoiceCharge="selectedApInvoiceCharge"
      />
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import Modal from '@/components/Modal'
import InvoiceChargeModal from '@/components/InvoiceChargeModal'
import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'InvoiceCharges',
  components: {
    PageContentLayoutOnly,
    ModernTable,
    Modal,
    InvoiceChargeModal
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {
    hoaId() {
      this.reload()
    },
    async toggle() {
      if (this.toggle == false) {
        await this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  async mounted() {
    this.apInvoiceID = this.$route.params.id || 0
    await this.reload()
  },

  i18n: {
    messages: {
      en: { invoiceCharges: { title: 'Charges' } }
    }
  }
}
</script>

<style></style>
